import { generatePath } from 'react-router-dom';
import {
	AI_ANALYSIS_ROUTES,
	DEAL_ROUTES,
	PEOPLE_ROUTES,
	ROUTES,
} from '@dealstack/frontend/app/pages/Routing/routes';
import { INGEST_PANEL, INGEST_SEARCH_PARAMS } from '../Ingestion/ingestion.constants';
import type { WorkspaceCategory } from './categories/categoryRegistry.types';

const CATEGORY_ROUTES: Record<WorkspaceCategory, AI_ANALYSIS_ROUTES> = {
	documents: AI_ANALYSIS_ROUTES.DOCUMENTS,
	securities: AI_ANALYSIS_ROUTES.SECURITIES,
	people: AI_ANALYSIS_ROUTES.PEOPLE,
	currencies: AI_ANALYSIS_ROUTES.CURRENCIES,
};

export const batchPath = (dealId: string, batchId: string): string =>
	generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.AI_ANALYSIS}${AI_ANALYSIS_ROUTES.BATCH}`, {
		dealId,
		batchId,
	});

export const categoryPath = (
	dealId: string,
	batchId: string,
	category: WorkspaceCategory
): string =>
	generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.AI_ANALYSIS}${CATEGORY_ROUTES[category]}`, {
		dealId,
		batchId,
	});

/** Review mode of a batch: the cap table, group structure and register check after the ready rows merge. */
export const reviewPath = (dealId: string, batchId: string): string =>
	generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.AI_ANALYSIS}${AI_ANALYSIS_ROUTES.REVIEW}`, {
		dealId,
		batchId,
	});

/** Directory root, where "Extract transaction from document" starts a new batch. */
const directoryPath = (dealId: string): string =>
	generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.PEOPLE}`, { dealId, personId: '' });

/** Transactions tab of the entity a batch was started from; the Directory when unknown. */
export const batchSourcePath = (dealId: string, sourcePersonId: string | null): string =>
	sourcePersonId
		? generatePath(`${ROUTES.DEAL}${DEAL_ROUTES.PEOPLE}${PEOPLE_ROUTES.TRANSACTIONS}`, {
				dealId,
				personId: sourcePersonId,
			})
		: directoryPath(dealId);

/** Batch list "+": the source entity's upload panel. */
export const newBatchPath = (dealId: string, sourcePersonId: string | null): string =>
	sourcePersonId
		? `${batchSourcePath(dealId, sourcePersonId)}?${INGEST_SEARCH_PARAMS.panel}=${INGEST_PANEL.UPLOAD}`
		: directoryPath(dealId);
